import { useState, useEffect } from 'react';

export const useOsDetection = () => {
    const [os, setOs] = useState('unknown');

    useEffect(() => {
        const userAgent = window.navigator.userAgent;
        if (userAgent.indexOf("Win") !== -1) setOs("Windows");
        else if (userAgent.indexOf("Mac") !== -1) setOs("macOS");
        else if (userAgent.indexOf("Linux") !== -1) setOs("Linux");
        else setOs("unknown");
    }, []);

    return os;
};